export default function preloadFont(fontUrl) {
  const linkElement = document.createElement('link')
  linkElement.rel = 'stylesheet'
  linkElement.href = fontUrl
  document.head.appendChild(linkElement)
}
